import React, {useEffect, useState} from 'react';
import styles from "./order.module.scss";
import {useTranslation} from 'react-i18next';
import {
    IStrategiesInfo,
    IToOrder,
    RecommendationLabel,
    StateOfTrade,
    StateOfTradeLabel,
    TimeFrames,
    TimeFramesLabel
} from "../../../../shared/types";
import {Button, Input} from "antd";
import advisor from "../../../../assets/images/advisor.png";
import {roundNumToRequiredPercent} from "../../../../shared/lib/lib";

interface Props {
    strategiesInfo: IStrategiesInfo | undefined,
    toOrder: IToOrder
    btnOrderLoading: boolean
    registerPositionHandler: (order: IToOrder) => void
    cancelOrderHandler: (strategy: string, ticker: string, timeframe: TimeFrames) => void
    openedFreeSignals: string[]
}

const Order = ({strategiesInfo, toOrder, btnOrderLoading, registerPositionHandler, cancelOrderHandler, openedFreeSignals}: Props) => {

    const {t, i18n} = useTranslation();

    const [price, setPrice] = useState(toOrder.price)
    const [stopLoss, setStopLoss] = useState(toOrder.stopLoss)
    const [takeProfit, setTakeProfit] = useState(toOrder.takeProfit)
    const [isFreeSignalAndOpened, setIsFreeSignalAndOpened] = useState(false)

    //округление цены в заявке, для простоты ввода реальной цены, так как с yahoo.finance приходят числа типа 125.45456461984616499
    useEffect(() => {
        const numRounded = roundNumToRequiredPercent(Number(toOrder.price), 0.1)
        setPrice(String(numRounded))
    }, [])

    const onChangeInputPrice = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value
        if (!isNaN(Number(newValue))) {
            setPrice(e.target.value)
        }
    }
    const onChangeInputStopLoss = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value
        if (!isNaN(Number(newValue))) {
            setStopLoss(e.target.value)
        }
    }
    const onChangeInputTakeProfit = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value
        if (!isNaN(Number(newValue))) {
            setTakeProfit(e.target.value)
        }
    }

    //определяем, может это сигнал по тикеру который уже занесен как фрии сигнал, то предупредим себя не забыть отправить и этот сигнал, чтобы серия по бесплатному сигналу не рушилась
    useEffect(() => {
        const ticker = toOrder.ticker
        if (openedFreeSignals.includes(ticker)) {
            setIsFreeSignalAndOpened(true)
        }
    }, [toOrder, openedFreeSignals])

    if (!strategiesInfo) {
        return null
    }

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <p className={styles.strategyTitle}><img src={advisor} alt="advisor"/>
                    {/*//@ts-ignore*/}
                    {t('AdvisorsOrderStrategy')}
                    - <span>{strategiesInfo[toOrder.strategy].label}</span>
                </p>
                <p className={styles.tickerTitle}>{toOrder.ticker}</p>
                <p className={styles.otherTitle}>
                    {/*//@ts-ignore*/}
                    {t('AdvisorsOrderTimeframe')} - {TimeFramesLabel[toOrder.timeframe as TimeFrames]}
                </p>
                <p className={styles.otherTitle}>
                    {/*//@ts-ignore*/}
                    {t('AdvisorsOrderAction')} - {t(RecommendationLabel[toOrder.actionType])} / {t(StateOfTradeLabel[toOrder.action as StateOfTrade])}
                </p>
                {/*//@ts-ignore*/}
                <p className={styles.otherTitle}>{t('AdvisorsOrderSpecificities')} - {toOrder.specificity}</p>
                {/*//@ts-ignore*/}
                <p className={styles.otherTitle}>{t('AdvisorsOrderVolume')} - {toOrder.value}</p>
                <p className={styles.otherTitle}>
                    {/*//@ts-ignore*/}
                    {t('AdvisorsOrderPrice')} - <input type="text" value={price} onChange={onChangeInputPrice}/>
                </p>
                <p className={styles.otherTitle}>
                    stop-loss - <input type="text" value={stopLoss}
                                       onChange={onChangeInputStopLoss}/>
                </p>
                <p className={styles.otherTitle}>
                    take-profit - <input type="text" value={takeProfit}
                                         onChange={onChangeInputTakeProfit}/>
                </p>
                {
                    isFreeSignalAndOpened &&
                    <p className={[styles.otherTitle, styles.warning].join(' ')}>Это бесплатный сигнал. Включи режим!</p>
                }
                <div className={styles.btns}>
                    <div className={styles.btnMake}>
                        <Button size={'small'} shape={'round'} loading={btnOrderLoading}
                                onClick={() => registerPositionHandler({
                                    strategy: toOrder.strategy,
                                    ticker: toOrder.ticker,
                                    timeframe: toOrder.timeframe,
                                    price: price,
                                    stopLoss: stopLoss,
                                    takeProfit: takeProfit,
                                    date: toOrder.date,
                                    actionType: toOrder.actionType,
                                    action: toOrder.action,
                                    value: toOrder.value,
                                    specificity: toOrder.specificity
                                })}>
                            {/*//@ts-ignore*/}
                            {t('AdvisorsOrderMakeDeal')}
                        </Button>
                    </div>
                    <div>
                        <Button size={'small'} shape={'round'} type={'primary'} loading={btnOrderLoading}
                                onClick={() => cancelOrderHandler(
                                    toOrder.strategy,
                                    toOrder.ticker,
                                    toOrder.timeframe,
                                )}>
                            {/*//@ts-ignore*/}
                            {t('AdvisorsOrderCancelOrder')}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Order;